export const servicesToPortTypes = {
    MESSAGING_SERVICE_ONLY: "Messaging Service Only",
    CALLING_AND_MESSAGING_SERVICES: "Calling and Messaging Services"
};

export const servicesToPortTypesArray = [
    servicesToPortTypes.CALLING_AND_MESSAGING_SERVICES,
    servicesToPortTypes.MESSAGING_SERVICE_ONLY,
];
